import propsTypes from "prop-types";
import { connect } from "react-redux";
import {
  AddToCart,
  AddToCartIcon,
  OffToCart,
  OffToCartIcon,
  QuantityNum,
} from "./style";

const Quantity = (props) => {
  const { theme, minCount, maxCount } = props;

  const { quantity, setQuantity } = props;

  const add = () => {
    if (maxCount && quantity >= maxCount) {
      alert();
    } else {
      setQuantity(quantity + 1);
    }
  };

  const remove = () => {
    if (quantity > minCount) {
      setQuantity(quantity - 1);
    }
  };

  return (
    <>
      <AddToCart
        className="btn"
        theme={theme}
        quantity={quantity}
        onClick={add}
      >
        <AddToCartIcon className="fa fa-plus"></AddToCartIcon>
      </AddToCart>
      {quantity ? <QuantityNum theme={theme}>{quantity}</QuantityNum> : false}

      <OffToCart
        className="btn"
        theme={theme}
        quantity={quantity}
        onClick={remove}
      >
        <OffToCartIcon className="fa fa-minus"></OffToCartIcon>
      </OffToCart>
    </>
  );
};

Quantity.propsTypes = {
  minCount: propsTypes.number,
  maxCount: propsTypes.number,
};

Quantity.defaultProps = {
  minCount: 0,
  maxCount: 50,
};

const mapStateToProps = (state) => {
  return {
    theme: state.theme,
  };
};

export default connect(mapStateToProps, false)(Quantity);
